import React from "react";

const Slogan = () => {
  return (
    <div className="flex flex-col items-center justify-center w-full mt-16 sm:mt-24 lg:mt-32 px-4 sm:px-6 lg:px-8 text-center">
      {/* Main Heading */}
      <h1 className="font-extrabold text-xl sm:text-2xl md:text-3xl lg:text-5xl tracking-wide text-gray-900">
        THE SMART EDUCATION PLATFORM
      </h1>

      {/* Subheading */}
      <p className="mt-3 sm:mt-4 md:mt-6 text-gray-700 text-sm sm:text-base md:text-lg lg:text-xl leading-relaxed">
        <i>where</i>{" "}
        <b className="text-gray-900 font-semibold">TECHNOLOGY</b>{" "}
        <i>drives</i>{" "}
        <b className="text-gray-900 font-semibold">EDUCATION</b>
      </p>

      {/* Optional decorative line (visual polish) */}
      <div className="mt-4 sm:mt-6 w-24 sm:w-32 lg:w-40 h-[2px] bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 rounded-full" />
    </div>
  );
};

export default Slogan;
